<script setup lang="ts">
import { onMounted, ref } from "vue";
import type { Category, CategoryResponse } from "./shared";
import CategoryItem from "./CategoryItem.vue";
import DotCarousel from "../../common/DotCarousel/index.vue";
import CategoriesSkeleton from "./CategoriesSkeleton.vue";
import { getMemoizedData } from "@/js/services/sharedDataService";

const props = defineProps<{
    categoriesRoute: string;
    categoryName: string;
    title: string;
}>();

const categories = ref<Category[]>([]);
const isLoading = ref(false);
const predefindeSizes = {
    default: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 3,
    "2xl": 3,
};

const getCategories = async () => {
    isLoading.value = true;
    try {
        const data: CategoryResponse = await getMemoizedData(props.categoriesRoute);

        const industryCategories = data.data.find(
            (category) =>
                category.name.toLowerCase() ===
                props.categoryName.toLocaleLowerCase(),
        );

        categories.value = industryCategories?.children || [];
    } catch (error) {
        console.error(error);
    } finally {
        isLoading.value = false;
    }
};

onMounted(() => {
    getCategories();
});
</script>

<template>
    <section class="w-full px-4 py-12 md:px-6 lg:pt-10 lg:pb-20 lg:px-16">
        <template v-if="isLoading">
            <CategoriesSkeleton />
        </template>

        <DotCarousel
            v-else
            :items-length="categories.length"
            :heading="title"
            navigation-position="top"
            :items-per-deifferent-sizes="predefindeSizes"
        >
            <CategoryItem
                v-for="category in categories"
                :key="category.id"
                :category="category"
            />
        </DotCarousel>
    </section>
</template>
